module.exports = __webpack_public_path__ + "media/steps/getauto_car_bcg-1920b48e.png";